import masterNUmberReducer from './masterNumberReducer';
export * from './masterNumberAction';
export default masterNUmberReducer;